import { Chevron, Button, Chip, Typography, useMediaQuery, useTheme, Box } from '@hermes/web-components'
import { UserListInterface } from '@hermes/types'
import React, { Dispatch, SetStateAction, useMemo } from 'react'
import Lottie from 'lottie-react'
import BookImage from '@components/BookImage'
import useTranslateMessage from '@hooks/useTranslateMessage'
import InlineLoaderAnimation from '@lib/assets/lottie/inline-loader.json'

import {
  MobileInlineListInfo,
  ListContainer,
  InlineList,
  InlineListInfo,
  BookImageContainer,
  DesktopTitle,
  CreateListButton
} from './Main.styles'

interface MainRouteProps {
  setRoute: Dispatch<SetStateAction<string>>
  setListId: Dispatch<SetStateAction<number | undefined>>
  lists: UserListInterface[]
}

const MainRoute = ({ setRoute, lists, setListId }: MainRouteProps) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('xs'))
  const { t } = useTranslateMessage()

  const sortedLists = useMemo(() => lists.sort((xItem, yItem) => Number(yItem.system) - Number(xItem.system)), [lists])

  return (
    <>
      <ListContainer>
        {!isMobile && (
          <DesktopTitle>
            <Typography variant="body2">{t({ id: 'modal.addBookToList.select' })}</Typography>
            <Button onClick={() => setRoute('create')} variant="outlined">
              {t({ id: 'modal.addBookToList.create' })}
            </Button>
          </DesktopTitle>
        )}
        {sortedLists.length ? (
          sortedLists.map((list) => (
            <Box key={list.id}>
              <InlineList
                onClick={() => {
                  setRoute('add')
                  setListId(list.id)
                }}
              >
                {!isMobile && (
                  <BookImageContainer>
                    <BookImage
                      src={list.books[0]?.fullImage}
                      alt={list.books[0]?.title}
                      width={32}
                      height={44}
                      style={{
                        objectFit: 'cover'
                      }}
                    />
                  </BookImageContainer>
                )}
                <InlineListInfo>
                  <Typography variant="body2">{list.title ?? t({ id: 'modal.addBookToList.myWishList' })}</Typography>
                  {!isMobile && (
                    <Typography className="books-length">
                      {t(
                        { id: 'modal.addBookToList.booksLength' },
                        {
                          books: list.books.length
                        }
                      )}
                    </Typography>
                  )}
                </InlineListInfo>
                {isMobile && (
                  <MobileInlineListInfo>
                    <Chip variant="outlined" label={list.books.length} />
                    <Chevron width="20px" style={{ rotate: '-90deg' }} />
                  </MobileInlineListInfo>
                )}
              </InlineList>
            </Box>
          ))
        ) : (
          <Box sx={{ width: '100%', display: 'inline-flex', justifyContent: 'center' }}>
            <Lottie style={{ width: '44px' }} animationData={InlineLoaderAnimation} loop={true} />
          </Box>
        )}
      </ListContainer>
      {isMobile && (
        <CreateListButton onClick={() => setRoute('create')}>
          {t({ id: 'modal.addBookToList.create' })}
        </CreateListButton>
      )}
    </>
  )
}

export default MainRoute
